import Web3 from 'web3'
import BigNumber from 'bignumber.js'
import { provider as ProviderType } from 'web3-core'
import { Contract } from 'web3-eth-contract'
import { AbiItem } from 'web3-utils'
import { GAS_PRICE } from 'config'
import erc20 from 'config/abi/erc20.json'
import multicall from 'utils/multicall'

const gasPriceInObj = GAS_PRICE?{gasPrice:GAS_PRICE}:{};

let tokens = [];
export const getAllTokens = async() => {
    if (!tokens || !tokens.length) {
        await fetch(`https://asset.benswap.cash/dexdefault.json`)
            .then((response) => response.json())
            .then((data) => {tokens = data;});
    }
    return tokens;
}
getAllTokens();

export const getTokenMetadata = async(tokenAddress) => {
  try {
    const info = await fetch(`https://asset.benswap.cash/assets/${tokenAddress}/info.json`)
      .then((response) => response.json());
    if (info) return info;
  } catch(e) {
    console.error(e);
  }
  return {};
}

export const getContract = (provider: ProviderType, address: string) => {
  const web3 = new Web3(provider)
  const contract = new web3.eth.Contract((erc20 as unknown) as AbiItem, address)
  return contract
}

export const getAllowance = async (
  lpContract: Contract,
  masterChefContract: Contract,
  account: string,
): Promise<string> => {
  try {
    const allowance: string = await lpContract.methods.allowance(account, masterChefContract.options.address).call()
    return allowance
  } catch (e) {
    return '0'
  }
}

export const getTokenBalance = async (
  provider: ProviderType,
  tokenAddress: string,
  userAddress: string,
): Promise<string> => {
  const contract = getContract(provider, tokenAddress)
  try {
    const balance: string = await contract.methods.balanceOf(userAddress).call()
    return balance
  } catch (e) {
    return '0'
  }
}

export const getBasicTokenInfo = async (tokenAddress: string) => {
  try {
    const calls = [
      {
        address: tokenAddress,
        name: 'name'
      },
      {
        address: tokenAddress,
        name: 'symbol'
      },
      {
        address: tokenAddress,
        name: 'decimals'
      }
    ];
    const [
      name,
      symbol,
      decimals
    ] = await multicall(erc20, calls);
  
    return {
      address: tokenAddress,
      name,
      symbol,
      decimals: new BigNumber(decimals).toNumber(),
    }
  } catch (e) {
    return {}
  }
}

export const transfer = async (erc20Contract, target, amount, account) => {
  try {
      return erc20Contract.methods
      .transfer(target, amount)
      .send({ ...gasPriceInObj, from: account})
      .on('transactionHash', (tx) => {
          return tx.transactionHash
      })
  } catch (err) {
      return console.error(err)
  }
}
